// extracted by mini-css-extract-plugin
module.exports = {"personaContainer":"styles_personaContainer__EV7Qt","loadingText":"styles_loadingText__liHhQ"};